import type { AccCheckerPaneProps } from "./components/AccCheckerPane";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, LazyImport, type LazyComponent, LazyAction, } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "AccChecker" */ "./lazyIndex"), { name: "AccChecker" });

export const AccCheckerPane: LazyComponent<AccCheckerPaneProps, unknown, void> = createLazyComponent(lazyModule, m => m.AccCheckerPane);

export const AccCheckerDrawer: LazyComponent<unknown, void> = createLazyComponent(lazyModule, m => m.AccCheckerDrawer);

export const lazyOpenChecker: LazyImport<typeof lazyIndex.openChecker, typeof lazyModule> = new LazyImport(lazyModule, m => m.openChecker);
export const lazyCloseChecker: LazyImport<typeof lazyIndex.closeChecker, typeof lazyModule> = new LazyImport(lazyModule, m => m.closeChecker);
export const lazyResetAccCheckerPane: LazyAction<typeof lazyIndex.resetAccCheckerPane, typeof lazyModule> = new LazyAction(lazyModule, m => m.resetAccCheckerPane);
